var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('CommonHeader',{attrs:{"title":"设备运营服务费返还","value":_vm.value}}),_c('LongList',{attrs:{"api-method":_vm.getData},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var list = ref.list;
return [_c('BillTable',{attrs:{"data":list,"columns":_vm.columns}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }